import { Link } from 'react-router-dom';
import './KitchenFittersPage.css';

const COLLECT = [
  {
    title: 'AC Units & Components',
    image: '/images/hvac/hvac-ac-units.png',
  },
  {
    title: 'Ductwork & Ventilation',
    image: '/images/hvac/hvac-ductwork.png',
  },
  {
    title: 'Copper Pipe & Tubing',
    image: '/images/hvac/hvac-copper-pipe.png',
  },
  {
    title: 'Metal Brackets & Frames',
    image: '/images/hvac/hvac-brackets-frames.png',
  },
  {
    title: 'Vent Covers & Grilles',
    image: '/images/hvac/hvac-vent-grilles.png',
  },
  {
    title: 'Coils & HVAC Hardware',
    image: '/images/hvac/hvac-components.png',
  },
];

const STEPS = [
  {
    n: '1',
    title: 'Post your scrap',
    body: 'Add photos, your postcode and what HVAC metal needs clearing from the job.',
  },
  {
    n: '2',
    title: 'We find collectors',
    body: 'Nearby licensed collectors review your listing and offer a collection window.',
  },
  {
    n: '3',
    title: 'Collector confirms',
    body: 'Agree access, parking and timing around your install or strip-out day.',
  },
  {
    n: '4',
    title: 'Scrap is collected',
    body: 'Units, ducting and copper leave the site through licensed handling routes.',
  },
  {
    n: '5',
    title: 'You get more done',
    body: 'Your team stays on installs while old HVAC metal is cleared away.',
  },
];

const REASONS = [
  {
    title: 'Licensed & verified collectors',
    body: 'Matched collectors are verified scrap carriers — not unlicensed tip runs.',
  },
  {
    title: 'Compliant & safe',
    body: 'Keep changeovers and strip-outs tidy with accountable metal clearances.',
  },
  {
    title: 'Cost effective',
    body: 'Post for free and avoid losing time hauling ducting and units yourself.',
  },
  {
    title: 'Better for the environment',
    body: 'Copper and HVAC metals are recovered for reuse instead of mixed waste.',
  },
  {
    title: 'Built for HVAC crews',
    body: 'Share access notes and photos so collectors arrive ready for bulky units.',
  },
];

const TRUST = [
  { label: 'Save time', detail: 'Clear job leftovers fast' },
  { label: 'Save money', detail: 'Free to post online' },
  { label: 'Recycle more', detail: 'Copper recovered properly' },
  { label: 'Stay compliant', detail: 'Licensed collectors only' },
];

export default function HvacAirConditioningPage() {
  return (
    <div className="kf-page">
      <section className="kf-hero" aria-labelledby="hvac-hero-heading">
        <div className="kf-hero-inner">
          <div className="kf-hero-copy">
            <p className="kf-kicker">SnapScrap for trade</p>
            <h1 id="hvac-hero-heading">
              Scrap collection for <span>HVAC & air-conditioning companies</span>
            </h1>
            <p className="kf-lead">
              Clear units, ducting and copper runs quickly and responsibly — so your next install or
              changeover stays tidy and on schedule.
            </p>

            <div className="kf-hero-actions">
              <Link className="kf-btn" to="/post-scrap">
                Post scrap free →
              </Link>
              <Link className="kf-btn kf-btn-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>

            <ul className="kf-trust">
              {TRUST.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="kf-hero-media">
            <img
              src="/images/businesses/biz-hvac.png"
              alt="HVAC and air-conditioning scrap ready for collection"
            />
            <p className="kf-hero-note">
              Built for HVAC crews — units, ducting, copper, brackets and grilles
            </p>
          </div>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="hvac-collect-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="hvac-collect-heading">What scrap we collect</h2>
            <p>Typical metal leftovers from HVAC installs, replacements and strip-outs</p>
          </header>

          <ul className="kf-collect-grid">
            {COLLECT.map((item) => (
              <li key={item.title}>
                <div className="kf-collect-image">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <h3>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-section kf-section-tint" aria-labelledby="hvac-steps-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="hvac-steps-heading">How SnapScrap works</h2>
            <p>Five simple steps from posting leftovers to a clear job site</p>
          </header>

          <ol className="kf-steps">
            {STEPS.map((step) => (
              <li key={step.n}>
                <span className="kf-step-n" aria-hidden="true">
                  {step.n}
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="hvac-why-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="hvac-why-heading">Why HVAC companies choose SnapScrap</h2>
            <p>Clear space, keep installs moving, and handle metal the responsible way</p>
          </header>

          <ul className="kf-why-grid">
            {REASONS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-cta" aria-label="Post scrap call to action">
        <div className="kf-cta-inner">
          <div className="kf-cta-copy">
            <h2>Post your HVAC scrap for free today</h2>
            <p>
              List leftovers from your next air-conditioning or ventilation job and get matched with
              a licensed collector.
            </p>
          </div>
          <Link className="kf-btn kf-btn-light" to="/post-scrap">
            Post scrap free →
          </Link>
        </div>
      </section>
    </div>
  );
}
